import api from 'Application/api/api';

const giveTemplateQuestionMultipleChoiceAnswers = (
    templateId,
    questionId,
    isCustom,
    answerIds,
    cancelToken = null,
) =>
    api.post(
        `project-manager/templates/${templateId}/questionnaire/questions/${questionId}/${
            isCustom ? 1 : 0
        }/answers/multiple-choice`,
        {
            answerIds,
        },
        { cancelToken },
    );

export default giveTemplateQuestionMultipleChoiceAnswers;
